import type { FlowUser } from "@/lib/auth";
import type { Workspace } from "@/lib/types";

/** Flow's super-admin realm role (mirrors the backend `flow-admin` bypass). */
const FLOW_ADMIN_ROLE = "flow-admin";

export function isFlowAdmin(user: FlowUser | null | undefined): boolean {
  return user?.roles?.includes(FLOW_ADMIN_ROLE) ?? false;
}

/** Whether the user may create a meeting series in this workspace. Mirrors the
 * backend gate in `routes/memos.py::create_series`: workspace owner/admin, or a
 * flow-admin (who bypasses membership). `workspace.role` is the caller's own
 * membership role, populated by `api.listWorkspaces()`. */
export function canCreateSeriesIn(
  workspace: Workspace,
  user: FlowUser | null | undefined,
): boolean {
  if (isFlowAdmin(user)) return true;
  return workspace.role === "owner" || workspace.role === "admin";
}

/** The subset of workspaces the user may create a meeting series in. */
export function workspacesUserCanCreateSeriesIn(
  workspaces: Workspace[],
  user: FlowUser | null | undefined,
): Workspace[] {
  if (isFlowAdmin(user)) return workspaces;
  return workspaces.filter((w) => canCreateSeriesIn(w, user));
}
